/** @format */

import { ProductSkuPrices } from './product-sku-prices.interface';
import { SkuDefiningAttribute } from './sku-defining-attribute.interface';
import { SkuDescriptiveAttribute } from './sku-descriptive-attribute.interface';

export interface ProductSkuCatalogDetails {
  partNumber: string;
  catentryId: number;
  prices: ProductSkuPrices;
  definingAttributes: SkuDefiningAttribute[];
  descriptiveAttributes: SkuDescriptiveAttribute[];
  name: string;
  parentPartNumber: string;
  parentCatentryId: number;
  fullImage: string;
  thumbnail: string;
  pdpSeoUrl: string;
  taxCode: number;
}
